const companyEN = {
  company: {
    help: {
      center: 'Help Center',
      popular: 'Popular articles',
      title: `We're here to help`,
      desc: 'Find answers to all your questions about how JCtrans can help you ship internationally and grow your business.',
      input: 'Ask a question or search by keyword',
      indexTitle1: 'PRODUCT HELP',
      how: 'How JCtrans Works',
      help: 'Product help',
      view: 'View all',
      file: 'Relevant attachments',
      noData: 'Sorry, nothing found for you, please try another keyword',
      all: 'View All Matching Articles',
    },
    about: {
      desc1: `JCtrans is the world's leading B2B platform for international logistics. We've built a globally trusted credit and cooperation system for freight forwarders, empowering forwarders to efficiently connect with business opportunities while minimizing cooperation risks.`,
      desc2: `Our core products and services include a diversified International Risk Protection Membership System, Global Events, Financial Services, and value-added digital solutions like AI Tools. By bringing together high-quality freight forwarders and supply chain partners worldwide, we deliver four core values: Cooperation Risk Protection, Business Opportunity Matching, Marketing and Promotion Services, and Reduce Costs and Boost Efficiency. `,
      descRefactor: `Guided by the principles of "Trustworthy" and "Mutual Benefit" and driven by the value of "Customers First", we are committed to becoming the most trusted international logistics platform, dedicated to helping freight forwarding companies globally achieve sustained profitability.`,
      desc3: ' 12,000+ paying members',
      desc4: `companies and more than 660,000 registered users worldwide.Annually, it facilitates over 2.2 million business opportunities, positioning JCtrans as one of the world's leading, fastest-growing logistics networks with the most abundant resources and business opportunities. The platform's supplier resources encompass upstream and downstream companies within the international logistics industry, including software tools, warehousing, customs brokers, trucking companies, shipping lines, and air freight carriers.`,
      desc: 'Build A Global Logistics Transaction & Settlement Platform',
      about: 'About JCtrans',
      poster:
        'JCtrans is the leading enterprise in the international logistics B2B platform, with a global community of over 10000+ paid members.',
      full: 'Full Video',
      history: `JCtrans's Lines of Development`,
      core: 'Core Values of JCtrans',
      cvs: 'Core Values',
      mission: 'Mission',
      missionDesc:
        'To help global freight forwarding companies achieve sustained profitability.',
      vision: 'Vision',
      visionDesc:
        'To become the most trustworthy international logistics trading platform.',
      values: 'Values',
      CustomersFirst: 'Customers First',
      AimForNumberOne: 'Aim for Number One',
      HonestyAndPragmatism: 'Honesty and Pragmatism',
      LearningAndInnovation: 'Learning and Innovation',
      TeamworkAndCollaboration: 'Teamwork and Collaboration',
      // business: 'Business',
      // businessDesc: 'Achieve success for our customers and ourselves.',
      // cooperation: 'Cooperation',
      // cooperationDesc:
      //   'Hold hands and walk together for a lasting partnership.',
      // innovation: 'Innovation',
      // innovationDesc:
      //   'Embrace change as the only constant, and continually improve.',
      products: 'Our Products',
      advantages: 'Our Advantages',
      advant: 'Advantages',
      leader: 'Leadership Team',
      contact: 'Contact Us',
      course: [
        {
          title: 'Transaction Digitization',
          tag: [
            {
              desc: 'Logistics consulting portal launched.',
            },
            {
              desc: 'Logistics community launched.',
            },
          ],
        },
        {
          title: 'Global Member Alliance',
          tag: [
            {
              desc: 'Introduction of the domestic and overseas membership product',
            },
            {
              desc: 'Inaugural Global Logistics Enterprise Development Summit held.',
            },
          ],
        },
        {
          title: 'Online Business Matchmaking',
          tag: [
            {
              desc: `The "Logistics Weibo" officially launched and operated.`,
            },
            {
              desc: 'International Credit and Cooperation Risk Protection Products launched.',
            },
          ],
        },
        {
          title: 'Diverse Service Platform',
          tag: [
            {
              desc: 'Domestic ocean freight payment service "USD Express" launched.',
            },
            {
              desc: 'Cross-border payment service for international freight forwarding, TCS, launched.',
            },
          ],
        },
        {
          title: 'Transaction Digitization',
          tag: [
            {
              desc: 'Cargo Owner Market successfully launched.',
            },
            {
              desc: 'The JCtrans brand was acquired.\nForwarder Helper Platform launched.',
            },
            {
              desc: `"Mini Alliance" affiliated to the member community system launched.\n“Forwarder Seeker” Platform launched.\nMobile version of "Forwarder Helper Platform" launched.`,
            },
            {
              desc: `The number of paid corporate members exceeds 10,000.\n“JCtrans Pay” launched.\nFurther perfected the digital transaction closed-loop system of the platform.\n“JCtrans Club” officially established.\n“JCtrans Customs Filling” platform launched.\n“JCtrans 货代圈” community marketing mini-program officially launched.\n“JCtrans Event” APP officially launched.`,
            },
            {
              desc: `Launch of “JCtrans Club” in Southeast Asia.\nProduct function upgrades for “JCtrans Customs Filling”, “JCtrans 货代圈”, and “JCtrans Event APP”.`,
            },
            {
              desc: `"Membership Cooperation Guidelines" officially launched.\n"Guaranteed Order Service" officially launched.\nMember Store Design Upgrade officially launched.`,
            },
          ],
        },
      ],
      advantagesList: [
        {
          tag: 'Credibility System',
          title:
            'Built a globally recognized freight forwarding cooperation credibility system.',
          desc: 'Established in 2003, with over 20 years of brand influence and credibility, our platform provides strong endorsement for cooperation between customers. Through big data technology and robust platform supervision, we have established an evaluation and reward-punishment mechanism, creating a reliable global freight forwarding cooperation credibility system. Every day, we attract 10,000 customers engaging in online business negotiations.',
        },
        {
          tag: 'Vast Resources',
          title: 'Integrated a vast pool of industry advantage resources.',
          desc: 'Our platform gathers 420,000 registered freight forwarding agent users from 181 countries and regions worldwide, along with 350,000 registered trade users and over 12,000 paid enterprise members. Our supplier resources cover both upstream and downstream of the international logistics industry, including warehousing, customs clearance, trucking, shipping lines, and airlines.',
        },
        {
          tag: 'High Quality Platform Service',
          title: 'Provided platform services exceeding industry standards.',
          desc: `Compared to other traditional freight forwarding alliance organizations, JCtrans platform services are more organized, disciplined, and customer-oriented, enabling a deeper understanding of our clients' business to help them succeed. We adhere to a customer-first service philosophy, with over 150 industry consultants providing specialized platform services 365 days a year. This approach makes freight forwarding business easier and simpler. The average annual renewal rate is over 88%.`,
        },
        {
          tag: 'Multiple Digital Products',
          title:
            'Developed multiple popular digital products that make freight forwarding business easier.',
          desc: 'We continuously invest in research and development. More than 100 research and development personnel continuously launch new products that connect people, cabins, and yards, assisting freight forwarding companies in cost reduction and efficiency improvement across marketing and customer acquisition, resource expansion, internal operations, and financial settlement.',
        },
      ],
      lines1: 'Advanced Logistics B2B Enterprise In China',
      lines2: `Top 10 Scientific And Technological Innovation Enterprises In China's Shipping Industry`,
      teamList: [
        {
          name: 'Jacy Qiu',
          position: 'Chairman and CEO',
        },
        {
          name: 'Dada Li',
          position: 'Vice President of Sales',
        },
        {
          name: 'Crystal Zheng',
          position: 'President of Community Business',
        },
        {
          name: 'Adam Wang',
          position: 'President of Finance and Innovation Business',
        },
        {
          name: 'Yorick Zhu',
          position: 'Director of Finance and Innovation Business',
        },
        {
          name: 'Leo Yang',
          position: 'Director of Product Design Center',
        },
        {
          name: 'Eric Lee',
          position:
            'Vice President of Technical Research and Development Center',
        },
        {
          name: 'Zhiquan Duan',
          position: 'Director of Operations Center',
        },
        {
          name: 'Seven Sun',
          position: 'Director of Customer Success',
        },
        {
          name: 'Cathy Chai',
          position: 'Director of Project Management',
        },
        {
          name: 'Alice Lou',
          position: 'Director of Client Relations',
        },
        // {
        //   name: 'Michael Li',
        //   position: 'President of Business Management',
        // },
      ],
      place: 'Office Location',
      place1:
        '6F, Tower 2, North Bund Jinmao Center, 323 Gongping Road, Hongkou District, Shanghai, China',
      place2:
        'Floor 24 - Zhong Xin Feng Yue Tower, 9 Chang Jiang East Rd, Zhong Shan District, Dalian, Liaoning',
      place3:
        'Room 1105, Block A, Aerospace Building, No. 4019 Shennan Avenue, Futian District, Shenzhen, Guangdong Province',
      place4:
        'Room 2206 - Tower 1, Long Hu Guang Nian, Sha Ping Ba District, Chongqing',
      joinTitle:
        'Join JCtrans and become a partner moving forward side by side',
      joinDesc: 'Resume Delivery',
    },
  },
}
const companyCN = {
  company: {
    help: {
      center: '帮助中心',
      popular: '热门问题',
      title: '我们全心全意为您提供帮助',
      desc: 'JCtrans能够为您提供在国际运输和发展业务相关问题的所有答案',
      input: '搜索问题或输入关键词',
      indexTitle1: '问题帮助',
      how: '视频教程',
      help: '产品帮助',
      view: '查看全部',
      file: '相关附件',
      noData: '对不起，您没有找到合适的关键词，请尝试其他关键字',
      all: '查看更多结果',
    },
    about: {
      desc1:
        'JCtrans杰西圈是全球领先的国际物流B2B平台，平台打造了全球可靠的货代合作信誉体系，帮助货代高效链接商机、降低合作风险。',
      desc2:
        '核心产品与服务包括多元化的国际信誉保障会员体系、全球物流会议、金融服务及数字化AI工具等增值服务。汇聚了全球优质的货运代理及上下游企业，提供合作风险保障、商机链接、营销推广和经营提效四大核心价值。',
      descRefactor:
        '始终秉持“值得信赖”和“利他共赢”的经营理念与“客户为先”的核心价值观，致力于成为最值得信赖的国际物流交易平台，帮助全球货运代理企业持续盈利。',
      desc3: '12,000+',
      desc4:
        '付费会员企业和超过77万的平台注册用户，全年促成商业机会超过350万次。跃居全球领先、增速最快、拥有资源和商机最多的物流社群网络之一，平台的供应商资源覆盖了国际物流行业上下游企业，包括软件工具、仓储、报关行、卡车公司、船公司、航空货运公司等。',
      desc: '打造全球物流交易结算平台',
      about: '关于JCtrans',
      poster:
        'JCtrans是国际物流B2B平台的领路人，拥有全球付费会员数超10000+的货运代理社群，持续打造最值得信赖的国际物流数字化交易平台，以帮助全球货运代理企业持续盈利。',
      full: '完整视频',
      history: 'JCtrans发展历程',
      core: '愿景使命',
      cvs: '愿景使命',
      mission: '使命',
      missionDesc: '帮助全球货运代理企业持续盈利',
      vision: '愿景',
      visionDesc: '成为最值得信赖的国际物流交易平台',
      values: '价值观',
      CustomersFirst: '客户为先',
      AimForNumberOne: '只做第一',
      HonestyAndPragmatism: '坦诚务实',
      LearningAndInnovation: '学习创新',
      TeamworkAndCollaboration: '团队合作',
      // business: '事业',
      // businessDesc: '成就客户，成就我们',
      // cooperation: '合作',
      // cooperationDesc: '手牵手一起走，走的更长久',
      // innovation: '创新',
      // innovationDesc: '唯一不变的是变化，持续改进',
      products: '我们的产品',
      advantages: '我们的优势',
      advant: '我们的优势',
      leader: '管理团队',
      contact: '联系我们',
      course: [
        {
          title: '信息资讯网站',
          tag: [
            {
              desc: '物流资讯门户上线',
            },
            {
              desc: '物流社区上线',
            },
          ],
        },
        {
          title: '全球会员联盟',
          tag: [
            {
              desc: '国内及海外会员制产品“信誉通”推出',
            },
            {
              desc: '首届全球物流企业发展峰会召开',
            },
          ],
        },
        {
          title: '线上商机撮合',
          tag: [
            {
              desc: `行业物流微博正式上线运营`,
            },
            {
              desc: '国际信誉保障产品上线',
            },
          ],
        },
        {
          title: '多元服务平台',
          tag: [
            {
              desc: '境内海运费支付“美元快付”上线',
            },
            {
              desc: '国际货运跨境支付TCS上线',
            },
          ],
        },
        {
          title: '交易数字化',
          tag: [
            {
              desc: '货主市场成功上线',
            },
            {
              desc: '杰西圈公司收购JCtrans品牌\n同行交易平台上线',
            },
            {
              desc: `会员联盟体系附属小联盟产品上线\n“找货代”平台上线\n“帮货代”移动端上线`,
            },
            {
              desc: `企业付费会员客户数突破10,000家\nJCtrans Pay上线，进一步完善了平台数字化交易闭环体系\n会员俱乐部正式成立\n全球海关申报平台上线\n社群营销小程序产品货代圈正式上线\n推出JCtrans Event APP`,
            },
            {
              desc: `东南亚会员俱乐部启动\n海关申报平台、货代圈、JCtrans Event APP功能升级`,
            },
            {
              desc: `推出“会员合作准则”\n推出“信保订单”\n会员店铺装修升级`,
            },
          ],
        },
      ],
      advantagesList: [
        {
          tag: '资源丰富',
          title: '打造了全球公认的货代合作信誉体系',
          desc: '品牌03年创立，超20年的品牌影响力和公信力为客户之间的合作提供强有力的信誉背书，通过大数据技术和平台强监管，建立评价和奖惩机制，打造了可靠的全球货代相互合作的信誉体系，每天吸引1万家客户在线进行业务洽谈。',
        },
        {
          tag: '圈层优质',
          title: '整合了规模庞大的产业优势资源',
          desc: '平台上汇聚了全球181个国家和地区的42万家注册货运代理用户，35万家注册贸易用户，以及1.2万多家付费企业会员。供应商资源覆盖国际物流行业上下游，包括仓储、报关行、拖车和卡车公司、船司和航司等。',
        },
        {
          tag: '生态开放',
          title: '提供了超行业标准的平台服务',
          desc: '相对其它传统货代联盟组织，JCtrans平台的服务更加有组织、有纪律、有温度，能够深入客户的业务，助力客户做好生意。我们始终秉持客户第一的服务理念，超过150名行业顾问365天全天候提供专业化平台服务，让货代生意更加轻松简单，平均年续费率达88%以上。',
        },
        {
          tag: '信誉可信',
          title: '研发了让货代生意更轻松的多个爆款数字化产品',
          desc: '平台持续加大产研投入力度，超过100名产研人员持续推出新产品，多重链接人、舱、场，助力货代企业在营销获客、拓展资源、内部操作、财务结算等环节全方位降本增效。',
        },
      ],
      lines1: '中国先进物流B2B企业',
      lines2: '中国航运业十大科技创新企业',
      teamList: [
        {
          name: '邱俊傑',
          position: '董事长兼CEO',
        },
        {
          name: '李一达',
          position: '销售负责人',
        },
        {
          name: '郑洁凝',
          position: '社群业务负责人',
        },
        {
          name: '王一鸣',
          position: '金融与创新业务总负责人',
        },
        {
          name: '朱辉',
          position: '金融与创新业务负责人',
        },
        {
          name: '杨棋磊',
          position: '产品设计中心及在线业务部负责人',
        },
        {
          name: '李炳峰',
          position: '技术研发中心负责人',
        },
        {
          name: '段志权',
          position: '运营中心负责人',
        },
        {
          name: '孙威',
          position: '客户成功负责人',
        },
        {
          name: '柴颖',
          position: '项目管理负责人',
        },
        {
          name: '娄慧思',
          position: '客情管理负责人',
        },
        // {
        //   name: '李文才',
        //   position: '经营管理负责人',
        // },
      ],
      place: '办公地点',
      place1: '上海市虹口区公平路323号北外滩金茂中心T2-6F',
      place2: '辽宁省大连市中山区长江东路9号中信丰悦大厦24层',
      place3: '广东省深圳市福田区深南大道4019号航天大厦A座1105',
      place4: '重庆市沙坪坝区龙湖光年1号楼2206',
      joinTitle: '加入JCtrans，成为并肩前行的伙伴',
      joinDesc: '简历投递',
    },
  },
}

export const en = companyEN.company
export const cn = companyCN.company
